import { HttpMethod, type IHttpClient } from '@/shared/contracts/http-client.contract';
import type { IUseCase } from '@/shared/contracts/use-case.contract';

import type { Request, Response } from '../type/update-profile';
import { ENDPOINT } from '../type/update-profile';

type UseCaseInput = Request;

type UseCaseOutput = Response;

export class UpdateProfileUseCase implements IUseCase<UseCaseInput, UseCaseOutput> {
  private client: IHttpClient;

  constructor(client: IHttpClient) {
    this.client = client;
  }

  async execute(input: UseCaseInput): Promise<UseCaseOutput> {
    return this.client.sendRequest<UseCaseOutput, UseCaseInput>({
      method: HttpMethod.POST,
      endpoint: ENDPOINT,
      body: input,
    });
  }
}
